<template>
  <v-row justify="center">
    <v-col md="8" lg="6" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="editForm">
          <v-card-title>
            <h2>{{ $t("admin.activities.diplomaCustomization.title") }}</h2>
            <v-spacer></v-spacer>
            <v-btn :loading="sampleDownloadInProgress" @click="downloadSample()" color=" primary" v-if="view">
              {{ $t("admin.activities.diplomaCustomization.sample") }}
            </v-btn>
            <v-btn @click="switchToEditMode()" class="ma-4" color=" primary" v-if="view">
              {{ $t("admin.activities.diplomaCustomization.edit") }}
            </v-btn>
          </v-card-title>
          <v-toolbar color="secondary" dark dense flat class="mt-3">
            <v-icon>mdi-image-area</v-icon>
            <v-toolbar-title class="ml-3">{{
              $t("admin.activities.diplomaCustomization.subheaders.backgroundImageUpload")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-subheader v-if="activity.diplomaBackgroundImageUrl" class="pl-0">{{
              $t("admin.activities.diplomaCustomization.backgroundImage")
            }}</v-subheader>
            <v-img
              v-if="activity.diplomaBackgroundImageUrl"
              :src="activity.diplomaBackgroundImageUrl || ''"
              contain
              class="mb-5"
              max-height="200px"
            >
              <v-btn
                @click="activity.diplomaBackgroundImageUrl = null"
                class="float-right ma-1"
                color="error"
                x-small
                v-if="activity.diplomaBackgroundImageUrl && editOn"
                fab
              >
                <v-icon dark>mdi-delete-forever</v-icon></v-btn
              >
            </v-img>
            <v-file-input
              :disabled="view"
              v-if="!activity.diplomaBackgroundImageUrl"
              :label="$t('admin.activities.diplomaCustomization.backgroundImage')"
              accept="image/*"
              v-model="fileBackgroundImage"
            ></v-file-input>
          </v-card-text>
          <v-toolbar class="mt-3" color="secondary" dark dense flat>
            <v-icon>mdi-format-paint</v-icon>
            <v-toolbar-title class="ml-3">{{
              $t("admin.activities.diplomaCustomization.subheaders.templateCustomization")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-radio-group :disabled="view" v-model="customTemplate">
              <v-radio :label="$t('admin.activities.diplomaCustomization.defaultTemplate')" :value="false"></v-radio>
              <v-radio :label="$t('admin.activities.diplomaCustomization.customizeHtml')" :value="true"></v-radio>
            </v-radio-group>
            <v-btn @click="loadDefaultTemplate()" color="primary" v-if="customTemplate">
              {{ $t("admin.activities.diplomaCustomization.loadDefault") }}</v-btn
            >
            <v-textarea
              :disabled="view"
              :label="$t('admin.activities.diplomaCustomization.diplomaCustomTemplate')"
              auto-grow
              v-if="customTemplate"
              v-model="activity.diplomaCustomHtml"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" v-if="!view">
              {{ $t("admin.activities.diplomaCustomization.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../../plugins/i18n";

const fileDownload = require("js-file-download");

export default {
  name: "ActivitiesEditDiplomaCustomization",
  mounted() {
    this.loadActivity();
  },
  methods: {
    async save() {
      this.loading = true;

      if (this.fileBackgroundImage) {
        let formData = new FormData();
        formData.append("file", this.fileBackgroundImage);
        const axiosResponse = await axios.post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.activity.diplomaBackgroundImageUrl = axiosResponse.serveURL;
      }

      if (!this.customTemplate) {
        this.activity.diplomaCustomHtml = null;
      }

      await this.$axios.put(`/admin/activities/${this.$route.params.id}`, this.activity);
      this.loading = false;

      this.switchToViewMode();
    },
    switchToEditMode() {
      this.view = false;
      this.editOn = true;
    },
    async downloadSample() {
      this.sampleDownloadInProgress = true;
      this.$axios({
        url: `/admin/activities/${this.activity.id}/sampleDiploma`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        this.sampleDownloadInProgress = false;
        fileDownload(
          response,
          `${this.activity.name} - ${i18n.t("admin.activities.diplomaCustomization.fileName")}.pdf`
        );
      });
    },
    switchToViewMode() {
      this.view = true;
      this.editOn = false;
    },
    async loadActivity() {
      if (this.$route.params.id) {
        this.activity = await this.$axios.get(`/event/activities/${this.$route.params.id}`);
        this.customTemplate = this.activity.diplomaCustomHtml != null;
      }
    },
    async loadDefaultTemplate() {
      this.activity.diplomaCustomHtml = await this.$axios.get(
        `/admin/activities/${this.activity.id}/defaultDiplomaTemplate`
      );
    },
  },
  data() {
    return {
      view: true,
      activity: {},
      customTemplate: false,
      editOn: false,
      fileBackgroundImage: null,
      sampleDownloadInProgress: false,
    };
  },
};
</script>

<style scoped></style>
